// #START Loading Actions
export const setLoading = loading => ({
  type: "SET_LOADING",
  loading
});
// #END Loading Actions

// #START Shade Ready Actions
export const setShadeReady = data => ({
  type: "SET_SHADE_READY",
  data
});
// #END Shade Ready Actions

// #START Engine Actions
export const setEngine = engine => ({
  type: "SET_ENGINE",
  engine
});
// #END Engine Actions

// #START QR Viewer
export const setQRView = status => ({
  type: "SET_QR_VIEW",
  status
});
// #END QR Viewer

// #START Info/Tips View
export const setPromptView = status => ({
  type: "SET_PROMPT_VIEW",
  status
});
// #END QR Viewer

// #START WebView not supported view
export const setWebViewPrompt = status => ({
  type: "SET_WEB_VIEW_PROMPT",
  status
});
// #END WebView

// #START session_id
export const setSessionID = sessionID => ({
  type: "SET_SESSION_ID",
  sessionID
});
// #END session_id

// #START product_id
export const setProductID = product_id => ({
  type: "SET_PRODUCT_ID",
  product_id
});
// #END product_id

// #START referrer
export const setReferrer = referrer => ({
  type: "SET_REFERRER",
  referrer
});
// #END referrer

// #START Loading Actions
export const setViewerSettings = viewer_settings => ({
  type: "SET_VIEWER_SETTINGS",
  viewer_settings
});
// #END Loading Actions


export const setDevice = data => ({
  type: "SET_DEVICE",
  data
});

export const setHeight = height => ({
  type: "SET_HEIGHT",
  height
});

export const setWidth = width => ({
  type: "SET_WIDTH",
  width
});


export const setHash = hash => ({
  type: "SET_HASH",
  hash
});

export const setOrigin = origin => ({
  type: "SET_ORIGIN",
  origin
});

export const setVariant = variant => ({
  type: "SET_VARIANT",
  variant
});
